module.exports = __webpack_public_path__ + "static/media/Niveau_elN8_4_850746.9ca4d6c0.png";